<template>
  <div class="white-skin">
    <mdb-side-nav :OpenedFromOutside.sync="toggle" mask="strong" logo="https://dev.gww-leadforge.de/static/img/gww-logo.svg" logoSn sideNavClass="sn-bg-1" ref="sideNav" fixed waves darkWaves>
      <li>
        <mdb-container>
          <mdb-select outline color="primary" v-model="eventSeriesOptions" placeholder="Veranstaltungsreihe wählen..." label="Veranstaltungsreihe"/>
        </mdb-container>
        <mdb-container>
          <mdb-select outline color="primary" v-model="eventYearOptions" placeholder="Jahr wählen..." label="Jahr"/>
        </mdb-container>
        <mdb-container>
          <mdb-select outline search color="primary" v-model="eventLocationOptions" placeholder="Veranstaltung wählen..." label="Veranstaltung"/>
        </mdb-container>
      </li>
      <li class="border-bottom border-light"></li>
      <li>
        <mdb-side-nav-nav>
          <mdb-side-nav-item header @click.native="toggle=false" icon="tachometer-alt" to="/dashboard">Dashboard</mdb-side-nav-item>
          <mdb-side-nav-item header @click.native="toggle=false" icon="chart-bar" to="/statistic">Statistik</mdb-side-nav-item>
          <mdb-side-nav-item header @click.native="toggle=false" icon="comment" far to="/message">Nachrichten</mdb-side-nav-item>
          <mdb-side-nav-item header @click.native="toggle=false" icon="history" to="/history">Verlauf</mdb-side-nav-item>
          <mdb-side-nav-cat name="Teilnehmer" icon="users">
            <mdb-side-nav-item @click.native="toggle=true" to="/participant/all">Alle</mdb-side-nav-item>
            <mdb-side-nav-item @click.native="toggle=false" to="/participant/einladungen">Ohne Einladung</mdb-side-nav-item>
            <mdb-side-nav-item @click.native="toggle=false" to="/participant/zusagen">Zusagen</mdb-side-nav-item>
            <mdb-side-nav-item @click.native="toggle=false" to="/participant/absagen">Absagen</mdb-side-nav-item>
            <mdb-side-nav-item @click.native="toggle=false" to="/participant/tickets">Ohne Ticket</mdb-side-nav-item>
          </mdb-side-nav-cat>
          <mdb-side-nav-item header @click.native="toggle=false" icon="file-contract" to="/quotation">Anfrage erstellen</mdb-side-nav-item>
          <!--<mdb-side-nav-cat name="Mitarbeiter" icon="users-cog">
            <mdb-side-nav-item @click.native="toggle=false" to="/mitarbeiter/alle">Alle</mdb-side-nav-item>
            <mdb-side-nav-item @click.native="toggle=false" to="/mitarbeiter/accounts">Accounts</mdb-side-nav-item>
            <mdb-side-nav-item @click.native="toggle=false" to="/mitarbeiter/tickets">Tickets</mdb-side-nav-item>
          </mdb-side-nav-cat>
          <mdb-side-nav-item header @click.native="toggle=false" icon="file-contract" to="/inquiry">Anfragen</mdb-side-nav-item>-->
        </mdb-side-nav-nav>
      </li>
    </mdb-side-nav>
  </div>
</template>

<script>
import { mdbContainer, mdbSideNav, mdbSideNavNav, mdbSideNavCat, mdbSideNavItem, mdbIcon, mdbSelect, waves } from 'mdbvue'

export default {
  name: 'SideNav',
  props: {
    waves: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean
    }
  },
  components: {
    mdbContainer,
    mdbSideNav,
    mdbSideNavNav,
    mdbSideNavCat,
    mdbSideNavItem,
    mdbIcon,
    mdbSelect,
    waves
  },
  data () {
    return {
      toggle: false,
      active: 0,
      elHeight: 0,
      windowHeight: 0,
      eventSeriesOptions: [
        { text: 'Alle', value: 'Alle', selected: true },
        { text: 'GWW-NEWSWEEK', value: 'GWW-NEWSWEEK' },
        { text: 'TREND', value: 'TREND' }
      ],
      eventYearOptions: [
        { text: 'Alle', value: 'Alle', selected: true },
        { text: '2015', value: '2015' },
        { text: '2016', value: '2016' },
        { text: '2017', value: '2017' },
        { text: '2018', value: '2018' },
        { text: '2019', value: '2019' },
        { text: '2020', value: '2020' }
      ],
      eventLocationOptions: [
        { text: '19.02.19 - Wuppertal', value: 'Wuppertal', selected: true },
        { text: '06.05.19 - Dresden', value: 'Dresden' },
        { text: '07.05.19 - Berlin', value: 'Berlin' },
        { text: '08.05.19 - Hamburg', value: 'Hamburg' },
        { text: '13.05.19 - Nürnberg', value: 'Nürnberg' },
        { text: '14.05.19 - München', value: 'Dresden' },
        { text: '15.05.19 - Stuttgart', value: 'Stuttgart' },
        { text: '16.05.19 - Offenbach', value: 'Offenbach' }
      ]
    }
  },
  methods: {
    afterEnter (el) {
      el.style.maxHeight = '1000px'
    },
    beforeLeave (el) {
      el.style.maxHeight = 0
    }
  },
  watch: {
    open (newVal) { // watch it
      this.toggle = true
    }
  },
  mixins: [ waves ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.side-nav .collapsible a {
  color: #424242;
}

.collapse-side-nav-item {
  overflow: hidden;
  max-height: 0;
  padding: 0;
  transition: max-height .3s;
}
.collapse-side-nav-item a {
  padding-left: 47px;
  line-height: 36px;
  background-color: rgba(0,0,0,.15);
}

</style>

<style>
.side-nav .collapsible a {
  font-size: 0.9rem !important;
}
.md-form.md-outline label.active {
  background-color: transparent !important;
  color: #004367 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SideNav.vue